/// auth service

export const LOGIN = 'admin/login';

export const CHANGE_PASSWORD = 'admin/changePassword';

export const LOGOUT = 'admin/logout';

export const DASHBOARD = 'admin/dashboard';